import { Component, Input, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController, ModalController } from 'ionic-angular';
import { ProductosElaboradosProvider } from '../../providers/productos-elaborados/productos-elaborados'
import { ProductosElaboradosContenidoDetallePage } from '../../pages/productos-elaborados-contenido-detalle/productos-elaborados-contenido-detalle'
import { productosElaboradosModelo }  from '../../models/productosElaborados'
import { ProductosElaboradosContenidoProvider } from '../../providers/productos-elaborados-contenido/productos-elaborados-contenido'
import { Storage } from '@ionic/storage'
import { CompaniasProvider } from '../../providers/companias/companias'
import { AuthService } from '../../providers/auth-service'
import { NUBE_AWS } from '../../config/url.servicio'

@IonicPage()
@Component({
  selector: 'page-productos-elaborados-contenido',
  templateUrl: 'productos-elaborados-contenido.html',
  providers: [ AuthService ]
})
export class ProductosElaboradosContenidoPage {
  data: any;
  events: any;
  buscar: any = "";
  buscarProductoElaboradoSimple: any = ""
  buscarProducto: any ="";
  allItems: any;
  allItemsProd: any
  productosElaborados = []
  productosElaboradosContenido = []
  productosElaboradosSimple = []
  busquedaSimpleMostrar :productosElaboradosModelo = {}
  busquedaContenidoMostrar :productosElaboradosModelo = {}
  productosElaboradosId: any

  public datos:productosElaboradosModelo = {}

  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  companiasId:any = null

  constructor(public navCtrl: NavController, public navParams: NavParams,
              public toastControllers:ToastController,
              public servicioProductosElaborados:ProductosElaboradosProvider,
              public modalControllers: ModalController,
              public servicioProductoselaboradosContenido:ProductosElaboradosContenidoProvider,
              public storage:Storage
              ,
              public servicioCompania:CompaniasProvider,
              public auth: AuthService
            ) {
                this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo','companiasId'])
                .then((val)=>{
                  if(val){
                    this.nombreCompaniaHeader = val['nombreCompania']
                    this.nombreCargoHeader = val['nombreCargo']
                    var valor = val['companiasId']
                    this.companiasId = valor
                    this.cargarProductos()
                  }
                })

}

cargarProductos() {
    this.productosElaborados = []
    this.servicioProductosElaborados.buscarProductoElaboradosCompania(this.companiasId)
    .subscribe(
      res => {
        this.productosElaborados = !NUBE_AWS ? res[0] : JSON.parse(res['_body']).data[0]
        },
      err => {
          this.mensajeToast('No se pudieron listar los productosElaborados, intente luego')
      }
    )
  }

  Detalle(datos:productosElaboradosModelo) {

    if(datos){
      this.datos = datos
      this.productosElaboradosId = this.datos['productosElaboradosId']

      this.cargarProductosElaboradosContenidos(this.datos)
    }
  }

  disminuirUnProductoElaborado(item, index) {
    let cantidadactual = item['cantidad']
    let descontar = 1
    let nuevaCantidad = 0
    nuevaCantidad = cantidadactual - descontar
    let valornuevo =JSON.stringify(nuevaCantidad)
    let valor = valornuevo.split('.');
    let sacarValor = 0
    let valorReal = ""
    let valorReales = 0
    let valorInicial = 0
    for(var i=0; i < valor.length;i++){
      if(i==valor.length -1){
        sacarValor = valor[i].length
        if(sacarValor>2){
          valorReal = valor[i]
          valorReal = valorReal.substr(0,1)
          valorReales = Number(valorReal) + 1
          sacarValor = Number(valorReales)
          let valores = ""
          valores = `${valorInicial}.${sacarValor}`
          nuevaCantidad = Number(valores)
        }

      }else{
        valorInicial = Number(valor[i])
      }
    }




    if(nuevaCantidad <= 0){
      this.productosElaboradosContenido[index]['cantidad'] = 0
    }else{
        this.productosElaboradosContenido[index]['cantidad'] = nuevaCantidad
  }
}

aumentarUnProductoElaborado(item, index) {
    let nuevaCantidad = Number(item['cantidad']) + 1
    this.productosElaboradosContenido[index]['cantidad'] = nuevaCantidad

}
mymodel:number
mymodelSimple:number
cantidadActual:number
cantidad:number
nuevacantidad:number
search(cantidadafn:any,item,index){
   setTimeout(() => {
      if(Number(cantidadafn['_value'])==0){
        return
      }
      let cantidadactual = Number(item['cantidad'])
      let cantidad = Number(cantidadafn['_value'])
      let nuevacantidad = cantidadactual +  cantidad
      this.cantidadActual = cantidadactual
      this.cantidad = cantidad
      this.nuevacantidad = nuevacantidad
      this.productosElaboradosContenido[index]['cantidad'] =  this.nuevacantidad
      cantidadafn['_value'] = 0
      this.mymodel = null
    },1000)
  }


disminuirUnProductoSimple(item, index) {
  let nuevaCantidad = Number(item['cantidad']) - 1

  let valornuevo =JSON.stringify(nuevaCantidad)
  let valor = valornuevo.split('.');
  let sacarValor = 0
  let valorReal = ""
  let valorReales = 0
  let valorInicial = 0
  for(var i=0; i < valor.length;i++){
    if(i==valor.length -1){
      sacarValor = valor[i].length
      if(sacarValor>2){
        valorReal = valor[i]
        valorReal = valorReal.substr(0,1)
        valorReales = Number(valorReal) + 1
        sacarValor = Number(valorReales)
        let valores = ""
        valores = `${valorInicial}.${sacarValor}`
        nuevaCantidad = Number(valores)
      }

    }else{
      valorInicial = Number(valor[i])
    }
  }

  if(nuevaCantidad <= 0){
    this.productosElaboradosSimple[index]['cantidad'] = 0
  }else{
      this.productosElaboradosSimple[index]['cantidad'] = nuevaCantidad
}
}

searchSimple(cantidadafnSimple:any,item,index){
  setTimeout(() => {
     if(Number(cantidadafnSimple['_value'])==0){
       return
     }
     let cantidadactual = Number(item['cantidad'])
     let cantidad = Number(cantidadafnSimple['_value'])
     let nuevacantidad = cantidadactual +  cantidad
     this.cantidadActual = cantidadactual
     this.cantidad = cantidad
     this.nuevacantidad = nuevacantidad
     this.productosElaboradosSimple[index]['cantidad'] =  this.nuevacantidad
     cantidadafnSimple['_value'] = 0
     this.mymodelSimple = null
   },1000)
 }


aumentarUnProductoSimple(item, index) {
  let nuevaCantidad = Number(item['cantidad']) + 1
  this.productosElaboradosSimple[index]['cantidad'] = nuevaCantidad
}


  cargarProductosElaboradosContenidos(datos:any) {
    this.productosElaboradosContenido = []
    this.productosElaboradosSimple = []
    this.allItemsProd = []
    this.storage.get('companiasId').then((val) => {
      let valores = []
      valores['companiasId'] = val
      valores['id'] = Number(datos.productosElaboradosId)

      this.servicioProductoselaboradosContenido.buscar(valores)
      .subscribe(
        res => {

         let busquedaSimple = 'P'
         let busquedaCompuesta = 'E'
         if(NUBE_AWS) {
          this.productosElaboradosContenido = JSON.parse(res['_body']).data[0].filter(e => e.tipo.indexOf(busquedaCompuesta) != -1)
          this.productosElaboradosSimple = JSON.parse(res['_body']).data[0].filter(e => e.tipo.indexOf(busquedaSimple) != -1)
          this.allItemsProd = this.productosElaboradosSimple
         } else {
          this.productosElaboradosContenido = res.filter(e => e.tipo.indexOf(busquedaCompuesta) != -1)

          this.productosElaboradosSimple = res.filter(e => e.tipo.indexOf(busquedaSimple) != -1)
          this.allItemsProd = this.productosElaboradosSimple
         }
        },
        err => {
        this.mensajeToast('No se pudieron traer los datos, intente luego')
        }
      )
    })
}


  ionViewDidLoad() {

  }

  getItems(event: any): void {
          if(!this.allItems){
            let valores = this.productosElaborados
            this.allItems = valores;
          }
            this.productosElaborados = this.allItems.filter((item) => {
              return item.nombreProductoElaborado.toLowerCase().indexOf(this.buscar.toLowerCase()) > -1;
            });
 }

  onEvent(event: string, item: any){

    if (event === 'onTextChange') {

       let valor = this.getItems(this.buscar);
       if(valor){
            item = valor
      }
  }
}

getItemsProd(event: any): void {
  if(!this.allItemsProd){
    let valores = this.productosElaboradosSimple
    this.allItemsProd = valores;
  }
    this.productosElaboradosSimple = this.allItemsProd.filter((item) => {
      return item.nombreProducto.toLowerCase().indexOf(this.buscarProductoElaboradoSimple.toLowerCase()) > -1;
    });
}

onEventProd(event: string, item: any){

if (event === 'onTextChange') {

let valor = this.getItemsProd(this.buscarProductoElaboradoSimple);
if(valor){
    item = valor
}
}
}
  mensajeToast(mensaje: string) {
    let item =    {
        "duration": 1000,
        "position": "buttom"
      }
      item["message"] = mensaje;
    let toast = this.toastControllers.create(item);
    toast.present();
  }

  editarproductosElaboradosContenido(data:any){
    let productosId = data.productosId
    var index = this.productosElaboradosSimple.indexOf(productosId);

    if (index > -1) {
      this.allItemsProd.splice(index, 1);
    }


    let valores = []
    this.buscarProductoElaboradoSimple = ""
    if(data.productosElaboradosContenidoId === "0"){
      valores['queHago'] = 'I'
      valores['cantidad'] = data.cantidad
      valores['productosId'] = data.productosId
      valores['productosElaboradosId'] = this.productosElaboradosId
    }else{
      valores['queHago'] = 'A'
      valores['cantidad'] = data.cantidad
      valores['productosId'] = data.productosId
      valores['productosElaboradosId'] = data.productosElaboradosId
      valores['productosElaboradosContenidoId'] = data.productosElaboradosContenidoId
    }
    if(data.cantidad === 0 && valores['queHago'] ==="I"){
      this.mensajeToast('La cantidad es 0 verifique...')
      return
    }
    this.guardarServicio(valores)
  }

  eliminarproductosElaboradosContenido(data:any){
    this.allItemsProd = []
    this.buscarProductoElaboradoSimple = ""
    let valores = []
    valores['productosElaboradosContenidoId'] = data.productosElaboradosContenidoId
    valores['productosElaboradosId'] = data.productosElaboradosId
    valores['queHago'] = 'E'
    this.guardarServicio(valores)
  }
  guardarServicio(data:any) {
    this.buscarProductoElaboradoSimple = ""
    let datosProductoElaboradoContenido: any = {}
    if(data.queHago ==="E"){
      datosProductoElaboradoContenido = {
        productosElaboradosContenidoId: data.productosElaboradosContenidoId,
        productosElaboradosId: data.productosElaboradosId,
        queHago: data.queHago,
        nombreTabla: "productosElaboradosContenido",
        name: "dataDynamicCrud"
      }
      this.servicioProductoselaboradosContenido.eliminar(datosProductoElaboradoContenido)
      .subscribe(
      res => {
        // this.cargarProductosElaboradosContenidos()
        this.mensajeToast('Registro guardado con exito...')
        this.cargarProductosElaboradosContenidos(data)
      },
      err => this.mensajeToast(err + ' Error al guardar con exito...')
      )


    }else{
      datosProductoElaboradoContenido = {
        productosElaboradosId: data.productosElaboradosId,
        productosElaboradosContenidoId: data.productosElaboradosContenidoId,
        productosId: data.productosId,
        cantidad: data.cantidad,
        queHago: data.queHago,
        nombreTabla: "productosElaboradosContenido",
        name: "dataDynamicCrud"
      }
      if(data.queHago ==="A"){
        this.servicioProductoselaboradosContenido.actualizar(datosProductoElaboradoContenido)
        .subscribe(
        res => {
          this.mensajeToast('Registro Actualizado con exito...')
          this.cargarProductosElaboradosContenidos(data)
        },
        err => this.mensajeToast(err + ' Error al Actualizar...')
        )
      }else{
        this.servicioProductoselaboradosContenido.guardar(datosProductoElaboradoContenido)
        .subscribe(
        res => {
          this.mensajeToast('Registro guardado con exito...')
          this.cargarProductosElaboradosContenidos(data)
        },
        err => this.mensajeToast(err + ' Error al guardar con exito...')
        )
      }
    }

  }
  cerrarSession(){
    this.auth.logout()
    this.navCtrl.setRoot('LoginPage');
  }


}



// WEBPACK FOOTER //
// ./src/pages/productos-elaborados-contenido/productos-elaborados-contenido.ts